import { apiClientAuth } from "../http/httpClient";


export function MaintenanceApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {
        
       /**
        * POST /api/maintenances
        * @desc    Create a new maintenance request
        * @access  Public - auth required
        * @param   {string} type - Type of maintenance (informatique, biomedicale, autres) - required
        * @param   {string} subtype - Subtype/description of maintenance (3-255 chars) - required
        * @param   {string} time - Time of maintenance request (HH:mm format) - required
        * @param   {date} date - Date of maintenance (ISO8601 format) - required
        * @param   {string} phone - Phone number (10-20 chars) - required
        * @param   {integer} userId - User ID submitting request (must be valid user) - required
        * @returns {Object} Success status with new maintenance request data
        */
        insert : (data) => https.post("/api/maintenances", data), 

        

      };
}

